import store from "@/store";
import moment from "moment";
import { SupportedLocaleCodes } from "@/data/enums/i18n";

export { moment };

export default {
  install: (Vue: any) => {
    // Define global '$moment' property
    Object.defineProperty(Vue.prototype, "$moment", {
      value: moment
    });

    /** Here we import the moment.js language file for the current active
     * locale and load it for the current vueMoment instance. We can skip
     * the 'EN' locale as this is included by default. */

    try {
      const { activeLocaleCode } = store.state.i18n;
      if (activeLocaleCode !== SupportedLocaleCodes.EN) {
        require(`moment/locale/${activeLocaleCode}`);
        moment.locale(activeLocaleCode);
      }
    } catch {
      // Silent catch
    }
  }
};
